import { IconButton, InputAdornment, Stack, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { CustomIconButton } from "./icon-button";
import { IoClose } from "react-icons/io5";

export const CommonTextField = (props) => {
  const {
    text,
    onTextChanged,
    placeholder = "",
    width = 100,
    height = 23,
    enableClear = false,
    debounceMs = 500,
    fontSize = 11,
    onKeyDown,
    onEnter,
    sx = {},
  } = props;
  const [current, updateCurrent] = useState(text);

  // 외부에서 text prop이 변경되면 내부 state 동기화
  useEffect(() => {
    updateCurrent(text ?? "");
  }, [text]);

  const resizeTimer = useRef(null);

  const handleUpdate = (value) => {
    updateCurrent(value);

    if (resizeTimer.current) {
      clearTimeout(resizeTimer.current);
    }

    if (debounceMs <= 0) {
      onTextChanged?.(value);
      return;
    }
    resizeTimer.current = setTimeout(() => {
      onTextChanged?.(value);
    }, debounceMs);
  };

  const handleChange = (event) => {
    handleUpdate(event.target.value);
  };

  const handleKeyDown = (event) => {
    onKeyDown?.(event);
    if (event.defaultPrevented) return;
    if (event.key === "Enter") {
      onTextChanged?.(event.target.value);
      onEnter?.(event.target.value, event);
    }
  };

  const handleClear = () => {
    updateCurrent("");
    onTextChanged?.("");
  };

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      sx={sx}
    >
      <TextField
        value={`${current}`}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        InputProps={{
          endAdornment: current ? (
            <InputAdornment
              position="end"
              sx={{ mr: -0.5 }}
            >
              <IconButton
                size="small"
                onClick={handleClear}
                sx={{ p: 0.2 }}
              >
                <IoClose style={{ fontSize: 14 }} />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          width,
          height,
          "& .MuiInputBase-root": {
            height: "100%",
            pr: current ? 0.5 : 1,
          },
          "& .MuiInputBase-input": {
            padding: 0,
            height: "100%",
            display: "flex",
            alignItems: "center",
            fontSize,
            ml: 1,
          },
        }}
      />
      {enableClear && (
        <CustomIconButton
          tooltip={"삭제"}
          onClick={() => handleUpdate("")}
        >
          <IoClose />
        </CustomIconButton>
      )}
    </Stack>
  );
};
